import { render, staticRenderFns } from "./CustomStatementsPage.vue?vue&type=template&id=e78ef586&scoped=true"
import script from "./CustomStatementsPage.vue?vue&type=script&lang=js"
export * from "./CustomStatementsPage.vue?vue&type=script&lang=js"
import style0 from "./CustomStatementsPage.vue?vue&type=style&index=0&id=e78ef586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78ef586",
  null
  
)

export default component.exports